<template>
  <div class="login-page">
    <div class="login-gradient">
      <div class="login-logo-wrapper">
        <img class="login-logo" src="../assets/Logo-sk.png" alt="Super Kompras" />
      </div>

      <div class="login-card-custom shadow-lg">
        <h2 class="login-title">Restablecer contraseña</h2>
        <p class="login-subtitle">Ingresa tu nueva contraseña</p>

        <div v-if="!token" class="alert alert-danger">
          El enlace no es válido.
          <router-link to="/auth/recuperar-contrasena" class="login-link">Solicita un nuevo correo de restablecimiento</router-link>.
        </div>

        <form v-else @submit.prevent="restablecer">
          <div class="mb-3">
            <label class="form-label">Nueva contraseña</label>
            <input v-model="nueva" :type="type" class="form-control login-input" placeholder="Mínimo 6 caracteres"
              required />
          </div>
          <div class="mb-3">
            <label class="form-label">Confirmar contraseña</label>
            <input v-model="confirmar" :type="type" class="form-control login-input"
              placeholder="Repite la nueva contraseña" required />
          </div>
          <button type="button" class="btn btn-link p-0 login-link" @click="type = type === 'password' ? 'text' : 'password'">
            {{ type === 'password' ? 'Mostrar contraseñas' : 'Ocultar contraseñas' }}
          </button>

          <button type="submit" class="btn btn-login w-100 mt-3" :disabled="enviando">
            {{ enviando ? 'Guardando...' : 'Guardar contraseña' }}
          </button>
        </form>

        <div class="text-center mt-3">
          <router-link to="/auth/login" class="login-link">Volver al inicio de sesión</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "RestablecerContrasena",
  data() {
    return {
      token: this.$route.query.token || "",
      nueva: "",
      confirmar: "",
      type: "password",
      enviando: false,
    };
  },
  methods: {
    async restablecer() {
      if (this.nueva.length < 6) {
        Swal.fire({ icon: "warning", title: "Contraseña inválida", text: "Debe tener al menos 6 caracteres." });
        return;
      }
      if (this.nueva !== this.confirmar) {
        Swal.fire({ icon: "warning", title: "No coinciden", text: "Las contraseñas no coinciden." });
        return;
      }
      this.enviando = true;
      try {
        await this.$store.dispatch("autenticacion/restablecerContrasena", {
          token: this.token,
          nueva: this.nueva,
        });
        await Swal.fire({
          icon: "success",
          title: "Contraseña restablecida",
          text: "Ya puedes iniciar sesión con tu nueva contraseña.",
        });
        this.$router.replace("/auth/login");
      } catch (e) {
        Swal.fire({ icon: "error", title: "Error", text: e.msg || "No se pudo restablecer la contraseña." });
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f7f7ff 0%, #6f6cfb 100%);
}

.login-gradient {
  width: 100%;
  padding: 40px 16px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-logo-wrapper {
  margin-bottom: 32px;
}

.login-logo {
  max-width: 260px;
  height: auto;
}

.login-card-custom {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px 48px 36px;
  max-width: 480px;
  width: 100%;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
  color: #222222;
}

.login-subtitle {
  text-align: center;
  margin-bottom: 24px;
  color: #8a8ba0;
}

.login-input {
  border-radius: 999px;
  padding: 10px 18px;
  border: 1px solid #e0e0f0;
  box-shadow: none;
}

.login-input:focus {
  border-color: #6f6cfb;
  box-shadow: 0 0 0 0.1rem rgba(111, 108, 251, 0.25);
}

.login-link {
  font-size: 0.875rem;
  text-decoration: none;
  color: #6f6cfb;
}

.btn-login {
  border-radius: 999px;
  background: #6f6cfb;
  border-color: #6f6cfb;
  color: #ffffff;
  font-weight: 600;
  padding: 10px 16px;
}

.btn-login:hover,
.btn-login:focus-visible,
.btn-login:active {
  background: #5c59e8;
  border-color: #5c59e8;
  color: #ffffff;
}

.btn-login:disabled {
  opacity: 0.7;
}

@media (max-width: 576px) {
  .login-card-custom {
    padding: 28px 20px 24px;
    border-radius: 16px;
  }

  .login-logo {
    max-width: 200px;
  }
}
</style>
